import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const PHONE = '972504647878';
const WA_MSG = encodeURIComponent('היי רומי, הגעתי מהאתר שלך ואשמח לשמוע עוד..');

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 80;
  window.scrollTo({ top, behavior: 'smooth' });
};

const NAV_LINKS = [
  { label: 'מי אני', targetId: 'story' },
  { label: 'לכל הקורסים', targetId: 'courses' },
  { label: 'מחשבון שכר פוטנציאלי', targetId: 'calculator' },
  { label: 'שאלות נפוצות', targetId: 'faq' },
  { label: 'צרי קשר', external: true, href: `https://wa.me/${PHONE}?text=${WA_MSG}` },
];

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <h3 className={styles.brandTitle}>
          Romi Peretz <span className={styles.brandSpan}>Academy</span>
        </h3>

        <nav className={styles.navRow}>
          {NAV_LINKS.map((item, i) =>
            item.external ? (
              <a
                key={i}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.navLink}
              >
                {item.label}
              </a>
            ) : (
              <button
                key={i}
                className={styles.navLink}
                onClick={() => scrollTo(item.targetId)}
              >
                {item.label}
              </button>
            )
          )}
        </nav>

        <div className={styles.contactRow}>
          <a href="tel:+972504647878" className={styles.contactItem}>050-464-7878</a>
          <span className={styles.dot} />
          <a href="mailto:Romiperetz88@gmail.com" className={styles.contactItem}>Romiperetz88@gmail.com</a>
        </div>
      </div>

      <div className={styles.divider} />

      <div className={styles.bottom}>
        <span>© 2025 Romi Peretz Academy</span>
        <Link to="/privacy" className={styles.privacyLink}>תקנון ומדיניות פרטיות</Link>
        <span className={styles.credit}>נבנה על ידי <a href="https://danielrozenblat.co.il" target="_blank" rel="noopener noreferrer" className={styles.bottomLink}>דניאל רוזנבלט</a></span>
      </div>
    </footer>
  );
}

export default Footer;
